"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const config = __importStar(require("../../config"));
const localforage_1 = __importDefault(require("localforage"));
const statefulpromise_1 = require("@/utils/statefulpromise");
const vue_1 = __importDefault(require("vue"));
const ENABLE_LOGGING = false;
const disk = localforage_1.default.createInstance({ name: "user" });
const state = {
    user: undefined,
    schedule: undefined,
    // exercises: {
    //     data: [],
    //     next: "",
    //     isLoading: false
    // },
    // exerciseDetails: {},
    workouts: {
        data: [],
        next: "",
        isLoading: false
    },
    programs: {
        data: [],
        next: "",
        isLoading: false
    },
};
const getters = {
    user: (state) => {
        return state.user;
    },
    schedule: (state) => {
        return state.schedule;
    },
};
// const actions: ActionTree<State, RootState> = {
//     async login(context: ActionContext<State, RootState>, payload: any) {
//         try {
//             const response: AxiosResponse = await axios.post(config.BASE_API + '/auth/anon', payload);
//             const user = {
//                 id: response.data.id,
//                 token: response.data.token
//             };
//             await disk.setItem("user", user);
//             context.commit('setUser', user);
//             return user;
//         } catch (err) {
//             console.log(err);
//             throw err;
//         }
//     },
//     async init(context: ActionContext<State, RootState>, payload: any) {
//         try {
//             await delay(1000);
//             const user = await disk.getItem("user");
//             context.commit('setUser', user);
//         } catch (err) {
//             console.log(err);
//             throw err;
//         }
//     },
//     async logout(context: ActionContext<State, RootState>, payload: any) {
//         try {
//             await axios.post(config.BASE_API + '/auth/logout', payload);
//             context.commit('setUser', null);
//         } catch (err) {
//             console.log(err);
//             throw err;
//         } finally {
//
//         }
//     }
// };
const mutations = {
    setUser: (state, user) => {
        if (ENABLE_LOGGING)
            console.log("user set state: ", state);
        if (ENABLE_LOGGING)
            console.log("user set: ", user);
        // state.user = user;
        vue_1.default.set(state, 'user', user);
    },
    setSchedule: (state, schedule) => {
        state.schedule = schedule;
    },
    addSchedule: (state, schedule) => {
        const next = Object.assign({}, state.schedule);
        next.data = Array.isArray(next.data) ? next.data.slice(0) : [];
        if (Array.isArray(schedule.data)) {
            next.data.push(...schedule.data);
        }
        if (!next.workouts) {
            next.workouts = {};
        }
        if (schedule.workouts) {
            for (const key of Object.keys(schedule.workouts)) {
                if (!next.workouts.hasOwnProperty(key)) {
                    next.workouts[key] = {
                        name: schedule.workouts[key].name,
                        slug: schedule.workouts[key].slug
                    };
                }
            }
        }
        if (!next.exercises) {
            next.exercises = {};
        }
        if (schedule.exercises) {
            for (const key of Object.keys(schedule.exercises)) {
                if (!next.exercises.hasOwnProperty(key)) {
                    next.exercises[key] = {
                        name: schedule.exercises[key].name,
                        slug: schedule.exercises[key].slug
                    };
                }
            }
        }
        next.until = schedule.until || next.until;
        vue_1.default.set(state, "schedule", next);
    },
    removeSchedule: (state, uuid) => {
        const next = Object.assign({}, state.schedule);
        if (Array.isArray(next.data)) {
            next.data = next.data.filter((item) => item.uuid !== uuid);
        }
        state.schedule = next;
    },
    // setExercises: (state: State, payload) => {
    //     const next = Object.assign({}, state.exercises);
    //     console.log("setExercises called: ", payload);
    //     if (Array.isArray(payload.data)) {
    //         next.data.push(...payload.data);
    //     }
    //     if (payload.hasOwnProperty('next')) {
    //         next.next = payload.next;
    //     }
    //     if (payload.hasOwnProperty('isLoading')) {
    //         next.isLoading = payload.isLoading;
    //     }
    //     state.exercises = next;
    // },
    // setExerciseDetails: (state: State, payload) => {
    //     const key = payload.key;
    //     const data = payload.data;
    //     if (payload.key) {
    //         Vue.set(state.exerciseDetails, key, data);
    //     }
    // },
    // deleteExercise: (state: State, payload) => {
    //     // TODO this seems to be very naive
    //     if (payload && payload.slug) {
    //         const slug = payload.slug;
    //         Vue.delete(state.exerciseDetails, slug);
    //         state.exercises.data = state.exercises.data.filter(item => item.slug !== slug);
    //     }
    //     if (payload && payload.uuid) {
    //         const uuid = payload.uuid;
    //         // TODO search through workout lists and delete it
    //     }
    // },
    setWorkouts: (state, payload) => {
        const next = Object.assign({}, state.workouts);
        if (Array.isArray(payload.data)) {
            next.data.push(...payload.data);
        }
        if (payload.hasOwnProperty('next')) {
            next.next = payload.next;
        }
        if (payload.hasOwnProperty('isLoading')) {
            next.isLoading = payload.isLoading;
        }
        state.workouts = next;
    },
    setPrograms: (state, payload) => {
        const next = Object.assign({}, state.programs);
        if (Array.isArray(payload.data)) {
            next.data.push(...payload.data);
        }
        if (payload.hasOwnProperty('next')) {
            next.next = payload.next;
        }
        if (payload.hasOwnProperty('isLoading')) {
            next.isLoading = payload.isLoading;
        }
        state.programs = next;
    },
};
// const module: Module<State, RootState> = {
//     namespaced: true,
//     state: state,
//     getters: getters,
//     actions: actions,
//     mutations: mutations
// };
function delay(millis) {
    return __awaiter(this, void 0, void 0, function* () {
        // this is just for testing
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, millis);
        });
    });
}
function makeUserModule(httpClient) {
    const module = {
        namespaced: true,
        state: state,
        getters: getters,
        actions: makeActions(httpClient),
        mutations: mutations
    };
    return module;
}
exports.default = makeUserModule;
function makeActions(httpClient) {
    const INFLIGHT_USER_SCHEDULE = {};
    let INFLIGHT_EXERCISES;
    let INFLIGHT_WORKOUTS;
    const actions = {
        signup(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield httpClient.post(config.BASE_API + '/auth/signup', payload);
                    const user = {
                        id: response.data.id,
                        token: response.data.token
                    };
                    yield disk.setItem("user", user);
                    context.commit('setUser', user);
                    return user;
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        login(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield httpClient.post(config.BASE_API + '/auth/login', payload);
                    const user = {
                        id: response.data.id,
                        token: response.data.token
                    };
                    yield disk.setItem("user", user);
                    context.commit('setUser', user);
                    return user;
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        forgotPassword(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield httpClient.post(config.BASE_API + '/auth/forgot-password', payload);
                    return response.data;
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        init(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                if (ENABLE_LOGGING)
                    console.log("init user");
                try {
                    yield delay(1000); // TODO TEMP ?
                    const user = process.env.VUE_ENV === 'server' ? undefined : yield disk.getItem("user");
                    if (ENABLE_LOGGING)
                        console.log("got user: ", user);
                    context.commit('setUser', user);
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        logout(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    yield httpClient.post(config.BASE_API + '/auth/logout', payload);
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
                finally {
                    yield disk.setItem("user", null);
                    context.commit('setUser', null);
                    context.commit('exercise/clearPrivateData', null, { root: true });
                }
            });
        },
        logTraining(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield httpClient.post(config.BASE_API + '/me/log', payload);
                    if (payload.scheduled) {
                        context.commit('removeSchedule', payload.uuid);
                    }
                    return "ok";
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        // async deleteExercise(context: ActionContext<State, RootState>, payload: any) {
        //     try {
        //         context.commit('deleteExercise', {
        //             uuid: payload.uuid,
        //             slug: payload.slug
        //         });
        //     } catch (err) {
        //         if (ENABLE_LOGGING) console.log(err);
        //         throw err;
        //     }
        // },
        scheduleTraining(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                if (ENABLE_LOGGING)
                    console.log("scheduleTraining: ", payload);
                try {
                    const data = {
                        entries: payload.data
                    };
                    if (payload.extra && payload.kind && payload.foreign_uuid) {
                        data.kind = payload.kind;
                        data.foreign_uuid = payload.foreign_uuid;
                        data.extra = payload.extra;
                    }
                    const response = yield httpClient.post(config.BASE_API + '/me/schedule', data);
                    context.commit('addSchedule', payload);
                    return "ok";
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        listSchedules(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let key;
                    if (payload && payload.until) {
                        key = "until:" + payload.until;
                    }
                    else if (payload && payload.from) {
                        key = "from:" + payload.from;
                    }
                    else {
                        key = "invalid";
                    }
                    if (INFLIGHT_USER_SCHEDULE[key] && !INFLIGHT_USER_SCHEDULE[key].isRejected()) {
                        return yield INFLIGHT_USER_SCHEDULE[key];
                    }
                    else {
                        let url = config.BASE_API + '/me/schedule';
                        if (payload && payload.until) {
                            url = url + "?until=" + payload.until;
                        }
                        else if (payload && payload.from) {
                            url = url + "?from=" + payload.from;
                        }
                        INFLIGHT_USER_SCHEDULE[key] = statefulpromise_1.toStatefulPromise(httpClient.get(url));
                        const response = yield INFLIGHT_USER_SCHEDULE[key];
                        const schedule = response.data;
                        context.commit('addSchedule', schedule);
                        return response;
                    }
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        // async listExercises(context: ActionContext<State, RootState>, payload: { more: boolean }) {
        //     try {
        //         if (context.state.exercises.isLoading) {
        //             return INFLIGHT_EXERCISES;
        //         } else {
        //             const pos = context.state.exercises.next;
        //             if ((!pos && context.state.exercises.data.length > 0)
        //                 || (!payload.more && context.state.exercises.data.length > 0)) {
        //                 return null;
        //             }
        //             const url = config.BASE_API + '/me/exercises' + (pos ? '?pos=' + pos : '');
        //             INFLIGHT_EXERCISES = toStatefulPromise(httpClient.get(url));
        //             context.commit('setExercises', {
        //                 isLoading: true
        //             });
        //             const response: AxiosResponse = await INFLIGHT_EXERCISES;
        //             const data = response.data.data.filter((exercise: any) => exercise.name);
        //             context.commit('setExercises', {
        //                 data: data,
        //                 next: response.data.next,
        //                 isLoading: false
        //             });
        //             return response;
        //         }
        //     } catch (err) {
        //         if (ENABLE_LOGGING) console.log(err);
        //         throw err;
        //     }
        // },
        listWorkouts(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (context.state.workouts.isLoading) {
                        return INFLIGHT_WORKOUTS;
                    }
                    else {
                        const pos = context.state.workouts.next;
                        if ((!pos && context.state.workouts.data.length > 0)
                            || (!payload.more && context.state.workouts.data.length > 0)) {
                            return null;
                        }
                        const url = config.BASE_API + '/me/workouts' + (pos ? '?pos=' + pos : '');
                        INFLIGHT_WORKOUTS = statefulpromise_1.toStatefulPromise(httpClient.get(url));
                        context.commit('setWorkouts', {
                            isLoading: true
                        });
                        const response = yield INFLIGHT_WORKOUTS;
                        context.commit('setWorkouts', {
                            data: response.data.data,
                            next: response.data.next,
                            isLoading: false
                        });
                        return response;
                    }
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
        listPrograms(context, payload) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (context.state.programs.isLoading) {
                        return INFLIGHT_WORKOUTS;
                    }
                    else {
                        const pos = context.state.programs.next;
                        if ((!pos && context.state.programs.data.length > 0)
                            || (!payload.more && context.state.programs.data.length > 0)) {
                            return null;
                        }
                        const url = config.BASE_API + '/me/programs' + (pos ? '?pos=' + pos : '');
                        INFLIGHT_WORKOUTS = statefulpromise_1.toStatefulPromise(httpClient.get(url));
                        context.commit('setPrograms', {
                            isLoading: true
                        });
                        const response = yield INFLIGHT_WORKOUTS;
                        context.commit('setPrograms', {
                            data: response.data.data,
                            next: response.data.next,
                            isLoading: false
                        });
                        return response;
                    }
                }
                catch (err) {
                    if (ENABLE_LOGGING)
                        console.log(err);
                    throw err;
                }
            });
        },
    };
    return actions;
}
